import {
    FETCH_CLIENT_SETTINGS,
    FETCH_CLIENT_ENABLED_COMMS,
    FETCH_EXTERNAL_STATUSES,
    FETCH_SERVICE_STATUS_SETTINGS,
    SET_CLIENT_SETTINGS_LOADING,
    SET_CLIENT_SETTINGS_SEARCH_VALUE,
    SET_SERVICE_STATUS_SETTINGS_LOADING
} from '../actions/actionTypes';

const initialState = {
    clientSearchValue:            '',
    clientSettings:               [],
    clientSettingsEnabledComms:   [],
    clientSettingsLoading:        false,
    clientSettingsMeta:           {},
    externalStatuses:             [],
    serviceStatusSearchValue:     '',
    serviceStatusSettings:        [],
    serviceStatusSettingsLoading: false,
    serviceStatusSettingsMeta:    {}
};

export default (state = initialState, action) => {
    switch (action.type) {
        case FETCH_CLIENT_SETTINGS:
            return {
                ...state,
                clientSettings:     [...action.payload.data],
                clientSettingsMeta: {...action.payload.meta}
            };
        case FETCH_CLIENT_ENABLED_COMMS:
            return {
                ...state,
                clientSettingsEnabledComms: [...action.payload.data]
            };
        case FETCH_EXTERNAL_STATUSES:
            return {
                ...state,
                externalStatuses: [...action.payload]
            };
        case FETCH_SERVICE_STATUS_SETTINGS:
            return {
                ...state,
                serviceStatusSettings:     [...action.payload.data],
                serviceStatusSettingsMeta: {...action.payload.meta}
            };
        case SET_CLIENT_SETTINGS_LOADING:
            return {
                ...state,
                clientSettingsLoading: action.payload
            };
        case SET_CLIENT_SETTINGS_SEARCH_VALUE:
            return {
                ...state,
                clientSearchValue: action.payload
            };
        case SET_SERVICE_STATUS_SETTINGS_LOADING:
            return {
                ...state,
                serviceStatusSettingsLoading: action.payload
            };
        default:
            return state;
    }
};
